/*global angular*/
/*global _*/

import jQuery from 'jquery';
import AppHelper from '../components/helpers/AppHelper';
import 'lodash';
import {react2angular} from 'react2angular';
import ModalCreateClink from '../../components/clinks/ModalCreateClink';
import ModalHistory from '../../components/clinks/ModalHistory';
import ModalEditClink from '../../components/clinks/ModalEditClink';
import ModalTrackingLinks from '../../components/clinks/ModalTrackingLinks';
import "ng-dialog/css/ngDialog-theme-default.min.css";
import "ng-dialog/css/ngDialog-theme-plain.min.css";
import "ng-dialog/css/ngDialog.min.css";
import "angular-ui-bootstrap/dist/ui-bootstrap-csp.css";
import "ng-tags-input/build/ng-tags-input.min.css";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import {PagesHelper} from "../../common/PagesHelper";
import {ColumnIds, IncludeExclude, PageName, UserPermissions} from "../../utils/types";
import dayjs from "../../utils/dayjs";
import StateHelper from '../../utils/StateHelper';
import ClinkNotesDropdown from '../../components/clinks/notes/ClinkNotesDropdown';
import ClinkTagsDropdown from '../../components/clinks/tags/ClinkTagsDropdown';
import TagsList from '../../components/clinks/tags/TagsList';
import ToggleStatsMode from '../../components/buttons/ToggleStatsMode';

var FLOAT_REGEXP = /^-?\d+((\.|,)\d+)?$/;
// missing variable during migration
const highlightHeader = false;

var app = angular.module('apt', [
    'ngDialog',
    'historyMain'
])
.config( ['$provide', function ($provide){
  $provide.decorator('$browser', ['$delegate', function ($delegate) {
      $delegate.onUrlChange = function () {};
      $delegate.url = function () { return ""};
      return $delegate;
  }]);
}])
// .config(['ngDialogProvider', function (ngDialogProvider) {
//     ngDialogProvider.setDefaults({
//     	onOpenCallback:  function() {
//             $(this).tooltip({
//                 selector:  '[data-toggle="tooltip"]',
//                 container: this,
//                 html: true
//             });              
//     	},
//     	preCloseCallback: function (e, $dialog) {
//     		// this is redundant
//     		// now that we've set the tooltips to have .ngdialog as their parent (which gets wiped when the dialog is closed)
//     		// but it's faster than waiting on that to propogate
//     		$(this).find(".tooltip[role=tooltip]").remove()    		
//     	}
//     });
// }])

.service('apt',function() { /*...*/ })
.component('modalEditClink',     react2angular(ModalEditClink,     ['clinkId', 'app', 'closeEditClink', 'reloadClink']))
.component('modalHistory',       react2angular(ModalHistory,       ['showHistory', 'setShowHistory', 'clink', 'app']))
.component('modalTrackingLinks', react2angular(ModalTrackingLinks, ['showTrackingLinks', 'setShowTrackingLinks', 'clinkid', 'previewLink', 'app']))
.component('modalCreateClink',   react2angular(ModalCreateClink,   ['app', 'campaign', 'closeCreateClink', 'currentUser']))
.component('clinkNotesDropdown', react2angular(ClinkNotesDropdown, ['clinkId', 'notes']))
.component('clinkTagsDropdown',  react2angular(ClinkTagsDropdown,  ['clinkId', 'reloadClink']))
.component('tagsList',           react2angular(TagsList,           ['tagsList']))
.component('toggleStatsMode',    react2angular(ToggleStatsMode,    ['showStats', 'setShowStats']))

.directive('smartFloat', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$parsers.unshift(function(viewValue) {
        if (FLOAT_REGEXP.test(viewValue)) {
          ctrl.$setValidity('float', true);
          return parseFloat(viewValue.replace(',', '.'));
        } else {
          ctrl.$setValidity('float', false);
          return undefined;
        }
      });
    }
  };
})

.directive( 'qcinfo', ['ngDialog', function( ngDialog ) {
	return {
	    scope: { qc: '=', campaign: '=', qclabel: '=', ignoreqc: '=', qcinuse: '=', qcison: '=', qcteststatus: '=', qcicon: '=' },
        controller: ['$scope', 'AppHelper', function( $scope, AppHelper ) {
        	$scope.retestQC = function( qcSystem, appID, demandSource, fullCampaignID ) {
         	    var params = {
         	    	'qcsystem':    qcSystem,
                    'appid':       appID,
                    'tracker':     demandSource,
                    'campaignid':  fullCampaignID
         	    };
         	    
            	AppHelper.requestQCRetest(
            		params,
            		function( data ) {
            			$scope.message = data.message
        			    ngDialog.open( {
        			    	template: data.status === 'success' ? 'static/dialogs/success.html' : 'static/dialogs/error.html',
        				    scope: $scope
        			    } );
            		},
            		function() {
            			$scope.message = "Failed to request a retest of the QC, there was a server error.";
        			    ngDialog.open( {
        			    	template: 'static/dialogs/error.html',
        				    scope: $scope
        			    } );
            		}
                );
         	};
         	         	
            $scope.tooltips = {
                ignoreVerification: "Overriden",
                tooManyHops: "QC Testing found more hops than the allowed max.",
                testedCountryNotTarget: "The country the campaign was tested in is not on this campaign's country target list."
            };
                    	
            $scope.getClassForCampaignIssueAttribute = function( okay, warning ) {
                if (!okay ) {
                  if ( warning ) {
                    return 'WARNING';
                  }
                  return 'PROBLEM';
                }
                return '';
              };
            
            $scope.getClassForApplicableAttribute = function( attributeApplicable ) {
                if ( !attributeApplicable ) {
                	return 'ci-not-applicable-attribute';
                }
                return '';
            };
            
            $scope.getTextForBoolean = function( booleanValue ) {
          	  if ( booleanValue ) {
          		  return 'Yes';
          	  }
          	  return 'No';
            };
            
            $scope.getClassForCampaignIssueHeader = function( campaignDashboardStatus ) {
            	if ( highlightHeader ) {
            		return 'ci-header-highlight';
            	}
            	return 'ci-header-lowlight';
            };
            
            $scope.getClassForHeaderHighlight = function( inUse ) {
            	if ( inUse ) {
            		return "ci-in-use";
            	}
            	return "ci-not-used";
            };
            
            $scope.getSuffixForHeader = function( inUse ) {
            	if ( inUse ) {
            		return "(In Use)";
            	}
            	return "";            	
            };
            
            $scope.getTextForFinalLink = function( appStore, appPage ) {
            	if ( appStore ) {
            		if ( appPage ) {
            			return "AppStore Page";
            		}
            		return "Wrong App";
            	}
            	return "Not AppStore";
            };
            
            $scope.getTextForValidHops = function( blacklisted, apptapLoopback ) {
            	if ( blacklisted ) {
            		return "Blacklisted Hop";
            	}
            	if ( apptapLoopback ) {
            		return "Loops to Kepler";
            	}
            	return "No";
            };
            
            $scope.toggleExpansionState = function( qcSystem, hopType, indexNum ) {
            	var hopDomain = document.querySelector( "#" + qcSystem + "-hop-domain-" + indexNum );
            	var hopURL = document.querySelector( "#" + qcSystem + "-hop-url-" + indexNum );
            	
            	if ( hopDomain && hopURL ) {
            		var elementToToggle = ( hopType === 'hop-domain' ? hopDomain : hopURL );
            		var elementToFollow = ( hopType !== 'hop-domain' ? hopDomain : hopURL );
            		
            		var elementToMakeHidden = ( elementToToggle.className.indexOf( 'ci-hop-visible' ) >= 0 ? elementToToggle : elementToFollow );
            		var elementToMakeVisible = ( elementToToggle.className.indexOf( 'ci-hop-hidden' ) >= 0 ? elementToToggle : elementToFollow );
            		            		
            		if ( elementToMakeHidden.className.indexOf( 'ci-hop-visible' ) >= 0 ) {
            			elementToMakeHidden.className = elementToMakeHidden.className.replace( 'ci-hop-visible', '' )
            		}
            		if ( elementToMakeHidden.className.indexOf( 'ci-hop-hidden' ) < 0 ) {
            			elementToMakeHidden.className = elementToMakeHidden.className + ' ci-hop-hidden';
            		}
            		
            		
            		if ( elementToMakeVisible.className.indexOf( 'ci-hop-hidden' ) >= 0 ) {
            			elementToMakeVisible.className = elementToMakeVisible.className.replace( 'ci-hop-hidden', '' )
            		}
            		if ( elementToMakeVisible.className.indexOf( 'ci-hop-visible' ) < 0 ) {
            			elementToMakeVisible.className = elementToMakeVisible.className + ' ci-hop-visibles';
            		}
            	}
            };
            
            $scope.toggleAllHops = function( qcSystem ) {
            	var toggleButton = document.querySelector( "#" + qcSystem + "-toggle-all" );
            	if ( !toggleButton ) {
            		return;
            	}
            	var expand = ( toggleButton.className.indexOf( 'fa-plus-square' ) >= 0 );
            	
            	var findingElements = true;
            	var indexNum = 0;
            	while ( findingElements ) {
            		var hopDomainElement = document.querySelector( "#" + qcSystem + "-hop-domain-" + indexNum );
            		var hopURLElement = document.querySelector( "#" + qcSystem + "-hop-url-" + indexNum );
            		
            		if ( hopDomainElement && hopURLElement ) {
            			if ( expand ) {
                    		if ( hopDomainElement.className.indexOf( 'ci-hop-visible' ) >= 0 ) {
                    			hopDomainElement.className = hopDomainElement.className.replace( 'ci-hop-visible', '' )
                    		}
                    		if ( hopDomainElement.className.indexOf( 'ci-hop-hidden' ) < 0 ) {
                    			hopDomainElement.className = hopDomainElement.className + ' ci-hop-hidden';
                    		}
            				
                    		if ( hopURLElement.className.indexOf( 'ci-hop-hidden' ) >= 0 ) {
                    			hopURLElement.className = hopURLElement.className.replace( 'ci-hop-hidden', '' )
                    		}
                    		if ( hopURLElement.className.indexOf( 'ci-hop-visible' ) < 0 ) {
                    			hopURLElement.className = hopURLElement.className + ' ci-hop-visible';
                    		}
            			}
            			else {
                    		if ( hopDomainElement.className.indexOf( 'ci-hop-hidden' ) >= 0 ) {
                    			hopDomainElement.className = hopDomainElement.className.replace( 'ci-hop-hidden', '' )
                    		}
                    		if ( hopDomainElement.className.indexOf( 'ci-hop-visible' ) < 0 ) {
                    			hopDomainElement.className = hopDomainElement.className + ' ci-hop-visible';
                    		}
            				
                    		if ( hopURLElement.className.indexOf( 'ci-hop-visible' ) >= 0 ) {
                    			hopURLElement.className = hopURLElement.className.replace( 'ci-hop-visible', '' )
                    		}
                    		if ( hopURLElement.className.indexOf( 'ci-hop-hidden' ) < 0 ) {
                    			hopURLElement.className = hopURLElement.className + ' ci-hop-hidden';
                    		}            				
            			}
            			
	            		indexNum = indexNum + 1;            			
            		}
            		else {
            			findingElements = false;
            		}
            	}
            	
            	if ( expand ) {
            		if ( toggleButton.className.indexOf( 'fa-plus-square' ) >= 0 ) {
            			toggleButton.className = toggleButton.className.replace( 'fa-plus-square', '' )
            		}            		
            		if ( toggleButton.className.indexOf( 'fa-minus-square' ) < 0 ) {
            			toggleButton.className = toggleButton.className + ' fa-minus-square';
            		}            		
            	}
            	else {
            		if ( toggleButton.className.indexOf( 'fa-minus-square' ) >= 0 ) {
            			toggleButton.className = toggleButton.className.replace( 'fa-minus-square', '' )
            		}            		
            		if ( toggleButton.className.indexOf( 'fa-plus-square' ) < 0 ) {
            			toggleButton.className = toggleButton.className + ' fa-plus-square';
            		}            		            		
            	}
            };
            
            $scope.copyHopsToClipboard = function( qcSystem ) {
            	var textArea = document.createElement( "textarea" );
            	textArea.value = "";
            	
            	var findingElements = true;
            	var indexNum = 0;
            	while ( findingElements ) {
            		var hopElement = document.querySelector( "#" + qcSystem + "-hop-url-" + indexNum );
            		if ( hopElement ) {
	            		textArea.value = textArea.value + "\n" + hopElement.innerText.trim();
	            		indexNum = indexNum + 1;
            		}
            		else {
            			findingElements = false;
            		}
            	}
            	textArea.value = textArea.value + "\n";
            	
            	var hopHeader = document.querySelector( "#" + qcSystem + "-hop-header" );
            	
            	if ( hopHeader ) {
                	hopHeader.appendChild( textArea );
            	}
            	else {
                	document.body.appendChild( textArea );            		
            	}
            	
            	textArea.focus();
            	textArea.select();
            	document.execCommand( 'copy' );

            	if ( hopHeader ) {
                	hopHeader.removeChild( textArea );
            	}
            	else {
                	document.body.removeChild( textArea );
            	}
            };
            
            $scope.qcTestStatusToolip = function( testStatus ) {
            	var tooltip = "QC test status has not been set."
            	if ( testStatus ) {            	
	            	switch( testStatus ) {
	            	    case "current":
	            	    	tooltip = "Latest QC results are current and up to date.";
	            	    	break;
	            	    case "testInProgress":
	            	    	tooltip = "QC testing currently in progress.";
	            	    	break;
	            	    case "needsTestng":
	            	    	tooltip = "This campaign needs OfferTest QC testing.";
	            	    	break;
	            	    case "configuredStatusNotActive":
	            	    	tooltip = "This campaign's configured status is not Active. OfferTest QC not being performed.";
	            	    	break;
	            	    case "effectiveStatusNotActive":
	            	    	tooltip = "This campaign's effective status is not Active. OfferTest QC not being performed.";
	            	    	break;
	            	    case "qcIgnored":
	            	    	tooltip = "This campaign is currently set to ignoring QC.  OfferTest QC not being performed.";
	            	    	break;
	            	    case "recentInstalls":
	            	    	tooltip = "This campaign has recent conversions.  OfferTest QC testing not needed.";
	            	    	break;
	            	    case "waitingForAppTapQC":
	            	    	tooltip = "The QC has not been performed yet.  Waiting until QC is complete.";
	            	    	break;
	            	    case "appTapQCWorking":
	            	    	tooltip = "The QC confirms campaign is working.  OfferTest QC testing not needed.";
	            	    	break;
	            	    case "testFailed":
	            	    	tooltip = "The most recent OfferTest QC request has failed.";
	            	    	break;
	            	    case "noCountryTarget":
	            	    	tooltip = "This campaign does not have any targeted countries.  Cannot perform OffertTest QC.";
	            	    	break;
	            	    case "invalidCountryTarget":
	            	    	tooltip = "This campaign's targeted country(s) cannot be tested by OfferTest.";
	            	    	break;
	            	    default: 
	            	    	tooltip = "Unknown QC test status: " + testStatus;
	            	}
            	}
            	
            	return tooltip;
            };
        }],
	    templateUrl: 'static/templates/qcinfo.html',
	};
}])

.directive('campaignstableforapp', ['ngDialog', function(ngDialog) {
  return {
    restrict: 'E',
    transclude: false,
    scope: {app: '=', clink: '=', campaigns: '=', showcreateclinkbutton: '=', matchingonly: '@', statsfieldname: '@' },
    link: function($scope, elm, attrs, ctrl) {
        $scope.campaign_sort   = { comparison:'stats.weekInstalls', reverse:true};
        $scope.currentPage = 1;
        $scope.pageSize = 20;
        $scope.canEditCLink = $scope.$parent.canEditCLink
        $scope.canEditClinkField = $scope.$parent.canEditClinkField

        $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData;
        $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
        $scope.currentUser = $scope.$parent.currentUser;
        $scope.plutoBaseUrl = process.env.REACT_APP_PLUTO_BASE_URL;

        $scope.isBrandProduct = function( productID ) {
          return productID.startsWith( "tile." );
        }

        // Listen for demand sources loaded event from React
        window.addEventListener('demandSourcesLoaded', function() {
          // Trigger digest cycle to update demand source labels
          $scope.$apply();
        });

        // Listen for traffic sources loaded event from React
        window.addEventListener('trafficSourcesLoaded', function() {
          // Trigger digest cycle to update traffic source labels
          $scope.$apply();
        });
  
        $scope.showPlacementRestrictions = function( campaign ) {
        	$scope.placementRestrictionCampaign = campaign;
        	ngDialog.open({
        	    template: 'static/dialogs/placementRestrictionsForCampaign.html',
              className: 'ngdialog-theme-default placement-restrictions-dialog',
        	    scope: $scope
        	});
        };
        
        $scope.sortCampaignsBy = function( column ) {
        	switch( column ) {
        		case 'Source':
        			$scope.campaign_sort.comparison = 'supplySource';
        			break;
        		case 'CampaignID':
        			$scope.campaign_sort.comparison = 'campaignID';
        			break;
        		case 'Payout':
        			$scope.campaign_sort.comparison = 'payout';
        			break;
        		case 'TodayBuys':
        			$scope.campaign_sort.comparison = 'stats.dayBuys';
        			break;
        		case 'TodayInstalls':
        			$scope.campaign_sort.comparison = 'stats.dayInstalls';
        			break;
        		case 'TodayRevenue':
        			$scope.campaign_sort.comparison = 'stats.dayRevenue';
        			break;
        		case 'WeekBuys':
        			$scope.campaign_sort.comparison = 'stats.weekBuys';
        			break;
        		case 'WeekInstalls':
        			$scope.campaign_sort.comparison = 'stats.weekInstalls';
        			break;
        		case 'WeekRevenue':
        			$scope.campaign_sort.comparison = 'stats.weekRevenue';
        			break;
        		case 'eCPC':
        			$scope.campaign_sort.comparison = 'stats.ecpc';
        			break;
        		default: break;
        	}
        	$scope.campaign_sort.reverse = !$scope.campaign_sort.reverse;
        };        
    },
    controller: ['$scope', 'AppHelper', '$q', 'ngDialog', function( $scope, AppHelper, $q, ngDialog ) {
    	function showCampaigns( campaigns ) {
    		if ( $scope.$eval($scope.matchingonly) ) {
    	    	$scope.filteredCampaigns = jQuery.grep( campaigns, function( c ) {
    	    		return c.campaignMatch;
    	    	});
        	} else {
        		$scope.filteredCampaigns = campaigns.slice(0);
        	}
    	}    	
      $scope.closeCreateClink = function() {
        $scope.showCreateClinkFromAngular = false;
        $scope.$apply();
      }
      $scope.createClink = function (app, campaign) {
				$scope.app = app;
				$scope.campaign = campaign;
        $scope.showCreateClinkFromAngular = true;
			}
      $scope.getDemandSourceLabel = function(demandSourceId) {
        return PagesHelper.getDemandSourceLabel(demandSourceId, false);
      }

    	showCampaigns( $scope.campaigns || [] );
    }],
    templateUrl: 'static/templates/campaigns_table_for_app.html',
    replace: false
  };
}])

.directive('clinkstableforapp', function() {
  return {
    restrict: 'E',
    transclude: false,
    link: function($scope, elm, attrs, ctrl) {
        $scope.isAdminUser = $scope.$parent.isAdminUser;
        $scope.isAllowedCampaigns = $scope.$parent.isAllowedCampaigns;
        $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData;
        $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
        $scope.canEditCLink = $scope.$parent.canEditCLink
        $scope.canEditClinkField = $scope.$parent.canEditClinkField
        $scope.clink_sort  = { comparison:'pub_id', reverse:false };
        $scope.currentUser = $scope.$parent.currentUser;

        $scope.sortClinksBy = function( column ) {
        	switch( column ) {
        		case 'clink ID':
        			$scope.clink_sort.comparison = 'clink_id';
        			break;
        		case 'Publisher':
        			$scope.clink_sort.comparison = 'pub_id';
        			break;
        		default: break;
        	}
        	$scope.clink_sort.reverse = !$scope.clink_sort.reverse;
        };
        
        $scope.invokeBulkEditCLinks = function( app ) {
          // Set the initial state for the bulk edit feature
          app.clinks.forEach( ( clink ) => clink.bulk_edit = false );
          app.bulk_edit_all_selected = false;

           app.bulk_edit_mode = true;
        };

        $scope.cancelBulkEditCLinks = function( app ) {
           app.bulk_edit_mode = false;
           app.clinks.forEach( ( clink ) => clink.bulk_edit = false );
        }

        $scope.selectAllForBulkEdit = function( app ) {
          app.bulk_edit_all_selected = !app.bulk_edit_all_selected

          app.clinks.forEach( function( clink, i ) {
             clink.bulk_edit = app.bulk_edit_all_selected;
          } );
        }
    },
    scope: {app: '=', clinks: '=', matchingonly: '@'},
    controller: ['$scope', 'AppHelper', '$q', '$filter', 'ngDialog', function( $scope, AppHelper, $q, $filter, ngDialog ) {
    	function showCLinks( cLinks ) {
        	if ( $scope.$eval($scope.matchingonly) ) {
    	    	$scope.filteredClinks = jQuery.grep( cLinks, function( c ) {
    	    		return c.campaignMatch;
    	    	});
        	} else {
        		$scope.filteredClinks = cLinks.slice(0);
        	}
    	}

      $scope.setShowHistory = function() {
        $scope.clinkIdToShowHistory = null;
        $scope.$apply();
      }
      $scope.showHistory = function(clink) {
        $scope.clinkIdToShowHistory = clink.clink_id;
      }

      $scope.closeEditClink = function() {
        $scope.showEditClinkFromAngular = false;
        $scope.$apply();
      }
      $scope.editClink = function(clink) {
        $scope.clink_id = clink.clink_id;
        $scope.showEditClinkFromAngular = true;
      }

      $scope.setShowTrackingLinks = function() {
        $scope.clinkIdToShowTrackingLinks = null;
        $scope.$apply();
      }
      $scope.showTrackingLinks = function(clink) {
        $scope.clinkIdToShowTrackingLinks = clink.clink_id;
      }

    	showCLinks( $scope.clinks || [] );

      $scope.reloadClink = function (clinkId, apply) {
        AppHelper.getClink( { 'clinkid': clinkId },
        function(updatedClink) {
          $scope.filteredClinks = $scope.filteredClinks.map((clink) => clink.clink_id === clinkId ? { ...clink, ...updatedClink } : clink);

          if (apply) $scope.$apply();
        })
      }
      $scope.buildConfiguredPayoutTooltip = function ( clink, isAdminUser ) {
        if (clink.configs[0].user_rev_share_p2p) {
          let message = 
            isAdminUser ? "Expected payout to publisher after rev-share. Payout will be a percentage of the credited payout to Kepler, and will vary depending on a number of factors. This will pay the publisher at (" + (clink.publisher_rev_share ? $filter('percentage')((clink.publisher_rev_share)) : "unknown") + ") of actual revenue credited to Kepler for a conversion. "
                        : "Payout is based on a rev-share of what Kepler is credited per conversion, and will vary depending on a number of factors."

          if (clink.stats && (clink.stats.todayInstalls || clink.stats.weekInstalls)) {
            message += 
              isAdminUser ? "Average recent payout to publisher per conversion after rev-share: " +  $filter('currency')((clink.stats.todayClicksCost+clink.stats.todayPublisherPayout)/clink.stats.todayInstalls) + " 1d, " +  $filter('currency')((clink.stats.weekClicksCost+clink.stats.weekPublisherPayout)/clink.stats.weekInstalls) + " 7d"
              : " Average recent payout: " + $filter('currency')((clink.stats.todayClicksCost+clink.stats.todayPublisherPayout)/clink.stats.todayInstalls) + " 1d, " +  $filter('currency')((clink.stats.weekClicksCost+clink.stats.weekPublisherPayout)/clink.stats.weekInstalls) + " 7d";
          } else {
            message += isAdminUser ?
              "No recent conversions for this cLink. Actual payout to publisher is unknown."
              : "No recent conversions for this cLink. Actual payout unknown until conversions credit.";
          }
          return message;
        } else {
          if (clink.configs[0].p2p) {
            return "cLink is configured to credit the publisher a fixed payout of (" + $filter('currency')(clink.configs[0].p2p) + ") per credited conversion.";
          } else {
            return "cLink is configured to not credit any revenue to the publisher. This is typically used for platforms where we buy traffic, rather than paying a partner per conversion or credited event.";
          }
        }
      };
    }],
    templateUrl: 'static/templates/clinks_table_for_app.html',
    replace: false
  };
})

.directive('clinkbulkeditbutton', function() {
  return {
    restrict: 'E',
    transclude: false,
    replace: true,
    scope: { app: '=', apps: '<', text:'@', icon:'='},
    controller: ['$scope', '$uibModal', 'ngDialog', function( $scope, $uibModal, ngDialog ) {
      var app = $scope.app;
      var clinks_to_bulk_edit = [];
      var cancelBulkEditFunction = $scope.$parent.cancelBulkEditCLinks;

      if ( $scope.app != null ) {
        clinks_to_bulk_edit = $scope.app.clinks;
      }
      else {
        $scope.apps.forEach( ( app ) => app.clinks.forEach( ( clink ) => clinks_to_bulk_edit.push( clink ) ) );
      }

      $scope.currentSelectionCount = function() {
        var count = 0;
        clinks_to_bulk_edit.forEach( ( clink ) => {
            if ( clink.bulk_edit ) {
              count++;
            }
        } );

        return count;
      };

			$scope.open = function() {
        // Cap the number of CLinks to bulk edit at 1,000.
        if ( $scope.currentSelectionCount() > 1000 ) {
          var dialogScope = $scope.$new(true);
          dialogScope.message = 'The maximum number of cLinks to bulk edit is 1,000.';
          ngDialog.open({
            template: 'static/dialogs/error.html',
            scope: dialogScope
          });

          return;
        }

        $uibModal.open({
					templateUrl: 'static/dialogs/bulkEditClinks.html',
					animation: false,
					windowClass: 'clink-bulk-edit-dialog modal-dialog-scrollable',

          controller: ['$scope', 'AppHelper', 'ngDialog', function( $scope, AppHelper, ngDialog ) {
            $scope.clinks = [];
            $scope.status = null;

            clinks_to_bulk_edit.forEach( function( clink, i ) {
              if ( clink.bulk_edit ) {
                $scope.clinks.push( clink );
              }
            } );

            $scope.updateClinks = function() {
              var clinkIDs = [];
              $scope.clinks.forEach( function( clink, i ) {
                clinkIDs.push( clink.clink_id );
              } );

              var params = { 
                'status':  $scope.status,
                'clinkid': clinkIDs.join( ',' )
              }

              AppHelper.changeClinkStatus( params,
                function() {
                  var dialogScope = $scope.$new(false);
                  dialogScope.message = 'cLinks Successfully Updated';
                    ngDialog.open({
                        template: 'static/dialogs/success.html',
                        scope: dialogScope,
                    preCloseCallback: function( ) {
                      $scope.$dismiss();
                    }
                    });              
                },
                function() {
                  var dialogScope = $scope.$new(true);
                  dialogScope.message = 'Error updating cLinks';
                  ngDialog.open({
                    template: 'static/dialogs/error.html',
                    scope: dialogScope,
                    preCloseCallback: function( ) {
                      $scope.$dismiss();
                    }
                  });
                },
                function() {
                  if ( app ) {                    
            			  cancelBulkEditFunction( app );
                  }
                  else {
                    cancelBulkEditFunction();                    
                  }
                }
              );
            }
          }]
        });
			};
    }],
    templateUrl: 'static/templates/clinkBulkEditButton.html'
  }
})

.directive('clinkstats', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { clink: '=', clinkid: '=', visible: '=' },
    controller: ['$scope', '$element', '$attrs', 'AppHelper', function( $scope, $element, $attrs, AppHelper ) {
        $scope.stats   = $scope.clink.stats;
    }],
    templateUrl: 'static/templates/clinkStats.html',
    replace: true
  };
})

.directive('productinfocardheader', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { cardtitle: '=', app: '=', campaign: '=' },
    controller: ['$scope', '$element', '$attrs', 'AppHelper', function( $scope, $element, $attrs, AppHelper ) {
      $scope.campaignid= $scope.campaign.campaignID;
      $scope.appid = $scope.app.appID || $scope.app.app_id;
      $scope.tracker = $scope.campaign.tracker;
      $scope.appicon = $scope.app.icon;
      $scope.apptitle = $scope.app.title;
    }],
    templateUrl: 'static/templates/productInfoCardHeader.html',
    replace: true
};
})

// Requires font-awesome to display properly
// platforms should be csv
.directive('platform', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { platforms: '=', ignore: '=', appid: '=' },
    controller: ['$scope', function( $scope ) {
      $scope.hasPlatform = function( plat ) {
        return $scope.platforms.indexOf( plat ) !== -1;
      };
      
      // TODO: this needs to be defined as part of the cLink/campaigns, not hacked in by the appID
      if ( $scope.appid && $scope.appid.indexOf("tile.") === 0 ) {
          $scope.isWeb = true;
          // $scope.isIgnore = true;  // was $scope.ignore which was incorrect, but with the corret setting the UI needs adjusting.
      } else {
          $scope.isAndroid = $scope.ignore || $scope.hasPlatform('android');
          $scope.isApple   = $scope.ignore || $scope.hasPlatform('iphone') || $scope.hasPlatform("ipad") || $scope.hasPlatform('ios');
          $scope.isPhone   = $scope.ignore || $scope.isAndroid || $scope.hasPlatform('iphone') || $scope.hasPlatform('ios');
          $scope.isTablet  = $scope.ignore || $scope.hasPlatform("ipad") || $scope.hasPlatform('ios');
          $scope.isDesktop = $scope.ignore || $scope.hasPlatform("desktop");
          $scope.isIgnore  = $scope.ignore === true;
      }
    }],
    templateUrl: 'static/templates/platform.html',
    replace: true
  };
})

.directive('demandsourcedetails', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { demandsource: '=' },
    controller: ['$scope', 'AppHelper', 'ngDialog', function( $scope, AppHelper, ngDialog ) {
      $scope.open = function() {
        $scope.loading = true;
        AppHelper.getDemandSourceSummary( {},
          function( data ) {
            for( var i=0; i<data.length; i++ ) {
              if( $scope.demandsource === data[i].name ) {
                $scope.data = data[i];
              } 
            }
            if( !$scope.data ) {
              $scope.message = "Could not find demand source details for this demand source"
              ngDialog.open({
                template: 'static/dialogs/warn.html',
                scope: $scope
              });
            } else {
              ngDialog.open({
                template: 'static/dialogs/showDemandSourceDetails.html',
                scope: $scope
              });
            }
          },
          function() {
            $scope.message = "There was a problem getting the demand source summary"
            ngDialog.open({
              template: 'static/dialogs/warn.html',
              scope: $scope
            });
          },
          function() {
            $scope.loading = false;
            $scope.$apply();
          }
        );
      };
    }],
    templateUrl: 'static/templates/demandSourceDetails.html',
    replace: true
  };
})

// Icon option requires font-awesome
.directive('campaignissues', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { campaign: '=', app: '=' },
    controller: ['$scope', 'AppHelper', 'ngDialog', function( $scope, AppHelper, ngDialog ) {
      $scope.campaignid=$scope.campaign.campaignID;
      $scope.appid = $scope.app.appID || $scope.app.app_id;
      $scope.tracker = $scope.campaign.tracker;

      $scope.open = function() {
        $scope.loadingIssues = true;
        AppHelper.getCampaignIssues( {'appid':$scope.appid, 'tracker':$scope.tracker, 'campaignid':$scope.campaignid, 'apiVersion':'2' },
          function( data ) {
            $scope.info = data;
            if( $scope.info.error === 'unconfigured' ) {
              $scope.message = "This campaign is not currently available in the live campaign feed. It may have been paused or removed in Pluto. Campaigns can remain cached in Jupiter for up to 60 days after removal."
              ngDialog.open({
                template: 'static/dialogs/warn.html',
                scope: $scope
              });
            } else {
              ngDialog.open({
                template: 'static/dialogs/showCampaignIssues.html',
                scope: $scope,
                className: 'ngdialog-theme-default campaignissues-dialog'
              });
            }

            $scope.$apply();
          },
          function() {
            $scope.message = 'Error getting campaign issues';
            ngDialog.open({
                template: 'static/dialogs/error.html',
                scope: $scope
            });
          },
          function() {
            $scope.loadingIssues = false;
          }
        );
      };

      $scope.getClassForCampaignIssueAttribute = function( okay, warning ) {
        if (!okay ) {
          if ( warning ) {
            return 'WARNING';
          }
          return 'PROBLEM';
        }
        return '';
      };
      
      $scope.getClassForApplicableAttribute = function( attributeApplicable ) {
        if ( !attributeApplicable ) {
        	return 'ci-not-applicable-attribute';
        }
        return '';
      };
      
      $scope.getTextForBoolean = function( booleanValue ) {
    	  if ( booleanValue ) {
    		  return 'Yes';
    	  }
    	  return 'No';
      };
      
      $scope.getTooltipForAttributeValue = function( attribute, value ) {
    	  if ( attribute === "campaignOverallStatus" ) {
	    	  if ( value === "Active" ) {
	    		  return "Campaign is active and healthy (or ignoring broken status) and is usable in feeds, apps, direct placements, and APIs.";
	    	  }
	    	  else if ( value === "Broken" ) {
	    		  return "Campaign does not work based on QC testing and is unusable.";
	    	  }
	    	  else if ( value === "Inactive" ) {
	        	  return "The campaign's configuration status prevents the campaign from being active and usable.";
	    	  }
    	  }
    	  else if ( attribute === "qcEnabled" ) {
    		  if ( value === "true:true" ) {
    			  return "Mobrand OfferTest QC is fully enabled and used for this campaign's health check.";
    		  }
    		  else if ( value === "true:false" ) {
    			  return "Mobrand OfferTest QC is partially enabled.  The campaign is being tested using OfferTest, but the results are not being used for campaign health checks.";
    		  }
    		  return "Mobrand OfferTest QC is not enabled for this campaign.";
    	  }
    	  else if ( attribute === "trackingServerActive" ) {
    		  if ( value  ) {
    			  return "The QC check is validating if the server hop before the app store is a recognized tracking server hop.";
    		  }
    		  return "The tracker server hop validation is disabled.";
    	  }
    	  else if ( attribute === "maxHopsActive" ) {
    		  if ( value ) {
    			  return "Max hops validation is enabled.  Campaign will not be used if it has more hops than the max allowed.";
    		  }
    		  return "The max hops validation is disabled.";
    	  }
    	  else if ( attribute === "ignoreQC" ) {
    		  if ( value ) {
    			  return "The results of the QC are being ignored.  This campaign is made active even if the QC results found it was broken.";
    		  }
    		  return "The results of the QC are not being ignored.";
    	  }
    	  
    	  return null;    	  
      };
     
      $scope.getConfiguredStatusText = function( configuredStatus ) {
    	  return configuredStatus.replace( /_/g, " " ).replace( /\w\S*/g,
            function( txt ) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            } );
      };
      
      $scope.getHealthStatusText = function( healthStatus ) {
    	  return healthStatus.replace( "IGNORE_", "" ).replace( /_/g, " " ).replace( /\w\S*/g,
            function( txt ) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            } );
      };
      
      $scope.getQCSystemDisplayName = function( qcSystem ) {
    	  if ( qcSystem === 'AppHelper' ) return "Kepler";
    	  else if ( qcSystem === 'mobrand-offertest' ) return "Mobrand OfferTest";
    	  return "None";
      }
      
      $scope.getQCEnabledText = function( qcON, qcUsed ) {
    	  if ( qcON ) {
    		  if ( qcUsed ) {
    			  return "Yes"
    		  }
    		  return "Partial (Testing Only)";
    	  }
    	  return "No";
      };
    }],
    templateUrl: 'static/templates/campaignIssues.html',
    replace: false
  };
})

// Icon option requires font-awesome
.directive('campaignevents', function() {
  return {
    restrict: 'E',
    transclude: true,
    /**
     *  Noobs beware! use lowercase or dash delimited attribute 
     *  names or you're gunna have a bad time.
     */
    scope: { knownevents: '=', app: '=', campaign: '=', icon:'=' },
    controller: ['$scope', 'AppHelper', 'ngDialog', function( $scope, AppHelper, ngDialog ) {
      $scope.open = function() {
          ngDialog.open({
            template: 'static/dialogs/showCampaignEvents.html',
            className: 'ngdialog-theme-default known-events-dialog',
            scope: $scope
          });         
      };
      $scope.numEvents = $scope.campaign.knownEvents.length
    }],
    templateUrl: 'static/templates/campaignevents.html',
    replace: true
  };
})

.directive('multiselect', function() {
  return {
    restrict: 'E',
    transclude: false,
    scope: { btntext:'@', headertext: '@', data:'=', ignored:'=' },
    controller: ['$scope', 'ngDialog', function( $scope, ngDialog ) {

      if( $scope.data ) {
        $scope.dataLength = $scope.data.length;
      }
      if( !$scope.dataLength ) {
        $scope.dataLength = _.keys( $scope.data ).length;
      }

      $scope.selectValues = function() {
          ngDialog.open({
              template: 'static/dialogs/multiselectPopup.html',
              scope: $scope,
              className: 'ngdialog-theme-default multiselect-dialog'
          });
      };

      $scope.getSelected = function() {
          return _.filter( $scope.data, function( item ) {
            if( !_.includes($scope.ignored, item ) ) {
              return item;
            }
          });
      };
      $scope.getDemandSourceLabel = function(demandSourceId) {
        return PagesHelper.getDemandSourceLabel(demandSourceId, false);
      };

      $scope.getSummary = function() {
          // set demand source button text
          var numIgnored = $scope.ignored ? $scope.ignored.length : 0 ;
          var numUsed    = $scope.data ? $scope.dataLength - numIgnored : 0;
          var used       = $scope.getSelected();
          var list       = [];
          var label      = null;
          
          if( !used || used.length === 0 ) {
            return 'None'; 
          } else if( !$scope.ignored || $scope.ignored.length === 0 ) {
            return 'All';
          }
          
          if( numIgnored > numUsed ) {
            label = '<div><strong>Only</strong></div>';
            
		    _.forEach( used, function( item ) {
              list.push( item );
            });
          } else {
            label = '<div><strong>All Except</strong></div>';
            _.forEach( $scope.ignored, function( item ) {
              list.push( item );
            });
          }
          
          _.forEach( list, function( item ) {
            label += '<div>' + $scope.getDemandSourceLabel(item) + '</div>';
          });
          
          return label;
      };

      $scope.init = function() {
        $scope.ignoredCopy = _.clone($scope.ignored);
      };

      $scope.getItemClass = function( item ) {
        if( _.includes($scope.ignoredCopy, item) ){
          return 'btn-danger';
        }
        return 'btn-success';
      };

      $scope.doubleClick = function( item ) {
        // add all to ignore list
        _.forEach( $scope.data, function( d ) {
          if( !_.includes($scope.ignoredCopy, d) ) {
            $scope.ignoredCopy.push( d.trim() );
          }
        });

        // remove the clicked item form ignore list
        $scope.ignoredCopy = _.without($scope.ignoredCopy, item.trim());
      };

      $scope.toggleItem = function( item ) {
        item = item.trim();
        if( $scope.ignoredCopy === undefined ) {
          $scope.ignoredCopy = [];
        }
        
        if( _.includes($scope.ignoredCopy, item) ) {
          $scope.ignoredCopy = _.without($scope.ignoredCopy, item);
        } else {
          $scope.ignoredCopy.push( item );
        }
      };

      $scope.selectAll = function() {
        $scope.ignoredCopy = [];
      };

      $scope.selectNone = function() {
        if( !$scope.ignoredCopy ) {
          $scope.ignoredCopy = [];
        }
        _.map( $scope.data, function( item ) {
          if( !_.includes( $scope.ignoredCopy, item ) ) {
            $scope.ignoredCopy.push( item );
          }
        });
      };

      $scope.canClose = function() {
        if( !$scope.ignoredCopy ) {
          $scope.ignoredCopy = [];
        }
        if( $scope.dataLength === $scope.ignoredCopy.length ) {
          $scope.message = 'You must allow at least one item';
          ngDialog.open({
            template: 'static/dialogs/error.html',
            scope: $scope
          });
          return false;
        } else {
          $scope.ignored = $scope.ignoredCopy;
          return true;
        }
      };

    }],
    templateUrl: 'static/templates/multiselect.html',
    replace: true
  };
})
  .directive('summarizedstats', function () {
    function map_campaign_data_for_options(campaign, type) {
      var campaignID = campaign.campaign_id ? campaign.campaign_id : campaign.campaignID;
      var supplySource = campaign.source ? campaign.source : campaign.supplySource;

      var title = supplySource + ":" + campaignID;
      return {
        "option_type": type,
        "campaignID": campaignID,
        "supplySource": supplySource,
        "id": supplySource + ":" + campaignID,
        "title": title,
        "stats": campaign.stats,
      }      
    }

    function build_stats_campaign_options($scope, app, clink, stats_campaigns) {
      var ret = {}

      // if a cLink is currently selected
      if ( $scope.options && $scope.options.selected_clink && $scope.options.selected_clink.campaigns ) {
        _.forEach( $scope.options.selected_clink.campaigns, function( campaign ) {
          var mapped = map_campaign_data_for_options(campaign, "cLink Campaigns");
          if ( !(mapped.id in ret) ) ret[ mapped.id ] = mapped;
        })
      }
      
      // if a cLink was the source of this, then show its campaigns
      if ( clink && clink.configs && clink.configs[0].campaigns ) {
        _.forEach( clink.configs[0].campaigns, function( campaign ) {
          var mapped = map_campaign_data_for_options(campaign, "cLink Campaigns");
          if ( !(mapped.id in ret) ) ret[ mapped.id ] = mapped;
        })
      }

      // if an app is available, show all applicable campaigns, split into matching and non-matching
      // for a search criteria (if applicable)
      if ( app && app.campaigns ) {
        _.forEach( app.campaigns, function( campaign ) {
          var mapped;
          if ( campaign.campaignMatch ) {
            mapped = map_campaign_data_for_options(campaign, "Searched Campaigns");
            if ( !(mapped.id in ret) ) ret[ mapped.id ] = mapped;
          } else {
            mapped = map_campaign_data_for_options(campaign, "Other Campaigns");
            if ( !(mapped.id in ret) ) ret[ mapped.id ] = mapped;
          }
        })
      }

      if ( stats_campaigns ) {
        _.forEach( stats_campaigns, function( campaign ) {
            var mapped = map_campaign_data_for_options(campaign, "Stats Campaigns");
            if ( !(mapped.id in ret) ) ret[ mapped.id ] = mapped;
        });
      }

      ret = Object.values(ret)
      ret.unshift({id: null, title: "All Campaigns"});
      return ret;
    }

    function map_clink_for_options(clink) {
      var clinkID = clink.clink_id || clink.clinkID;
      var pubName = clink.pub_name || clink.publisherName;
      var pubID = clink.publisher_id || clink.publisherID || clink.pub_id;
      var siteID = clink.site_id || clink.siteID;
      
      if ( !pubName ) {
        pubName = "Other Publishers";
      }

      return {
        clinkID: clinkID,
        publisherName: pubName,
        publisherID: pubID,
        siteID: siteID,
        title: clinkID,
        campaigns: clink.configs ? clink.configs[0].campaigns : null
      }
    }

    function build_clinks_options(app, clink, stats_clinks) {
      var ret = {};

      if ( clink ) {
        var mapped = map_clink_for_options(clink);
        if ( !(mapped.clinkID in ret) ) ret[mapped.clinkID] = mapped;
      }
      
      if ( app && app.clinks ) {
        _.forEach(app.clinks, function(c) {
          var mapped = map_clink_for_options(c);
          if ( !(mapped.clinkID in ret) ) ret[mapped.clinkID] = mapped;
        })
      }

      if ( stats_clinks ) {
        _.forEach(stats_clinks, function(c) {
          var mapped = map_clink_for_options(c);
          if ( !(mapped.clinkID in ret) ) ret[mapped.clinkID] = mapped;
        })
      }

      ret = Object.values(ret)
      ret = _.sortBy(ret, 'clinkID')
      ret.unshift({clinkID: null, title: "All cLinks"});
      return ret;
    }

    function map_publisher_for_options(pub) {
      var pubName = pub.pub_name || pub.publisherName;
      var pubID = pub.publisherID || pub.publisher_id || pub.pub_id;
      var siteID = pub.site_id || pub.siteID;
      
      // Get traffic sources from global state to get proper names
      var trafficSources = StateHelper.getTrafficSourcesArray();
      var actualPublisherName = pubName;
      var actualSiteName = siteID;
      
      if (trafficSources && pubID) {
        var trafficSource = trafficSources.find(function(t) { 
          return t.record && t.record.apptapPublisherId === pubID; 
        });
        var publisherRecord = trafficSource && trafficSource.record ? trafficSource.record : null;
        
        if (publisherRecord) {
          actualPublisherName = publisherRecord.apptapPublisherName || pubName;
          
          if (siteID && publisherRecord.publisherSites) {
            var publisherSiteRecord = publisherRecord.publisherSites.find(function(publisherSite) { 
              return publisherSite.apptapSiteId === siteID; 
            });
            if (publisherSiteRecord && publisherSiteRecord.apptapPublisherSiteName) {
              actualSiteName = publisherSiteRecord.apptapPublisherSiteName;
            }
          }
        }
      }

      return {
        publisherName: actualPublisherName, // This is the group name
        siteName: actualSiteName, // This is the option display name
        publisherID: pubID,
        siteID: siteID,
        id: pubID + ":" + siteID,
        publisherGroup: actualPublisherName || "Unknown Publisher" // Group by publisher name
      }
    }

    function build_publishers_options( app, clink, stats_publishers ) {
      var ret = {};

      // clink has the key "publisher" fields we need, so pull in the current cLink
      // just to make sure even publishers without recent stats are represented in the list
      if ( clink ) {
        var mapped = map_publisher_for_options(clink);
        ret[mapped.publisherName] = mapped
      }

      // clink has the key "publisher" fields we need, so pull in the current app cLinks, if any
      // just to make sure even publishers without recent stats are represented in the list
      if ( app && app.clinks ) {
        _.forEach(app.clinks, function(c) {
          var mapped = map_publisher_for_options(c);
          ret[mapped.publisherName] = mapped
        })
      }

      if ( stats_publishers ) {
        _.forEach(stats_publishers, function(p) {
          var mapped = map_publisher_for_options(p);
          ret[mapped.publisherName] = mapped
        })
      }

      ret = Object.values(ret)
      ret = _.sortBy(ret, 'publisherName')
      ret.unshift({id: null, siteName: "All Sites"});
      return ret;
    }

    function build_country_options( app, clink, stats_countries ) {
      var targeted = {};
      var other = {}
      
      if ( clink && clink.configs ) {
        var countries = clink.configs[0].countries.split(/[ ,]/);
        _.forEach(countries, function(c) { targeted[c] = {countryCode: c, type: "Targeted", title: c} })
      }

      // clink has the key "publisher" fields we need, so pull in the current app cLinks, if any
      // just to make sure even publishers without recent stats are represented in the list
      if ( app ) {
        countries = app.countries.split(/[ ,]/);
        _.forEach(countries, function(c) { targeted[c] = {countryCode: c, type: "Targeted", title: c} })
      }

      if ( stats_countries ) {
        _.forEach(stats_countries, function(c) {
          if ( c.countryCode && !(c.countryCode in targeted) ) {
            other[c.countryCode] = {countryCode: c.countryCode, type: "Out of Target", title: c.countryCode};
          }
        })
      }

      // countries is a long list, so put the sorted targeted on top, then sorted mistargeted
      var ret = _.sortBy(Object.values(targeted), 'countryCode')
      ret = ret.concat(_.sortBy(Object.values(other), 'countryCode'))
      ret.unshift({countryCode: null, title: "All Countries"} )
      return ret;
    }

    function refresh_options($scope) {
      $scope.options_clinks = build_clinks_options( $scope.app, $scope.clink, $scope.stats_clinks );
      $scope.options_publishers = build_publishers_options( $scope.app, $scope.clink, $scope.stats_publishers )
      $scope.options_countries = build_country_options( $scope.app, $scope.clink, $scope.stats_countries )
      if ( $scope.isAllowedCampaigns ) {
        $scope.options_campaigns = build_stats_campaign_options( $scope, $scope.app, $scope.clink, $scope.stats_campaigns );
      } else {
        $scope.options_campaigns = []
      }
    }

    /**
     * If there's a selected cLink, tries to select the associated publisher if it can be found
     * If not found, clears the selected publisher so the cLink search alone controls the query.
     */
    function selectCLinkPublisher($scope) {
      if ( $scope.options.selected_clink && $scope.options.selected_clink.publisherID ) {
        var publishers = _.filter($scope.options_publishers, function(p) { 
          return p.publisherID === $scope.options.selected_clink.publisherID
              &&
                p.siteID === $scope.options.selected_clink.siteID;
        });
        if ( publishers ) {
          $scope.options.selected_publisher = publishers[0];
        } else {
          $scope.options.selected_publisher = $scope.options_publishers[0];
        }
      }
    }

    function setDashboardV2LinkAndGetParams (groupByArg, scope){

      const appID = scope.app == null ? null : scope.app.appID;
      const source = scope.options.selected_campaign ? scope.options.selected_campaign.supplySource : null;
      const campaignID = scope.options.selected_campaign ? scope.options.selected_campaign.campaignID : null;
      const clinkID = scope.options.selected_clink ? scope.options.selected_clink.clinkID : null;
      const countryCode = scope.options.selected_country ? scope.options.selected_country.countryCode : null;
      const publisherID = scope.options.selected_publisher ? scope.options.selected_publisher.publisherID : null;
      const siteID = scope.options.selected_publisher ? scope.options.selected_publisher.siteID : null;

      const params = {
        'appID': appID,
        'source': source ,
        'campaignID': campaignID,
        'clinkID': clinkID,
        'countryCode': countryCode,
        'publisherID': publisherID,
        'siteID': siteID
      }
      const productsAndCampaignsForProductsPage = StateHelper.getProductsAndCampaignsState(PageName.products);
      let campaign = null;
      if (campaignID && productsAndCampaignsForProductsPage.dto && productsAndCampaignsForProductsPage.dto.campaignsResponse) {
        campaign = productsAndCampaignsForProductsPage.dto.campaignsResponse.find((campaign) => campaign.campaignId === campaignID && campaign.campaignSource === source);
      }
      
      //BEGIN - Building link URL to dashboard
      const allNull = appID === null && source === null && campaignID === null && clinkID === null && countryCode === null && publisherID === null && siteID === null;

      //The URL start with slash, so it respects the current domain and port
      const pageState = {
        page : PageName.products,
        placementsIncludeExclude: IncludeExclude.Include,
        trafficSourcesIncludeExclude: IncludeExclude.Include,
        trafficTypesIncludeExclude: IncludeExclude.Include,
        countriesIncludeExclude: IncludeExclude.Include,
        productsIncludeExclude: IncludeExclude.Include,
        campaignsIncludeExclude: IncludeExclude.Include,
        cLinksIncludeExclude: IncludeExclude.Include,
        viewAs : null,
        pivotBy : null
      };

      if ( scope.options.selected_date ) {
        pageState.dateStart = dayjs.utc(scope.options.selected_date);
        pageState.dateEnd = dayjs.utc(scope.options.selected_date);
      }
      else{
        // Use the actual dates from the all_dates array (which comes from backend data)
        if (scope.all_dates && scope.all_dates.length > 0) {
          // Use the actual first and last dates from the data
          // all_dates[0] is the most recent date, all_dates[length-1] is the oldest
          const newestDate = scope.all_dates[0];
          const oldestDate = scope.all_dates[scope.all_dates.length - 1];
          pageState.dateStart = dayjs.utc(oldestDate);
          pageState.dateEnd = dayjs.utc(newestDate);
        } else {
          // Fallback to 7 days if no data yet
          const endDate = dayjs.utc();
          const startDate = endDate.subtract(6, 'days');
          pageState.dateStart = startDate;
          pageState.dateEnd = endDate;
        }
      }

      // Initialize all filter properties to null
      pageState.productIds = null;
      pageState.demandSourceIds = null;
      pageState.campaignIds = null;
      pageState.cLinks = null;
      pageState.publisherIds = null;
      pageState.siteIds = null;
      pageState.countries = null;

      if( allNull === false){
        pageState.productIds = appID ? appID : null;
        if (campaignID && source) {
          pageState.demandSourceIds = [source];
          pageState.campaignIds = [campaignID];
        } else if (campaign) {
          const campaignSourceAndId = PagesHelper.getCampaignSourceAndCampaignID(campaign);
          const parts = campaignSourceAndId.split(':');
          if (parts.length === 2) {
            pageState.demandSourceIds = [parts[0]];
            pageState.campaignIds = [parts[1]];
          }
        }
        pageState.cLinks = clinkID ? [clinkID] : null;
        if (siteID) {
          pageState.siteIds = [siteID];
        } else if (publisherID) {
          pageState.publisherIds = [publisherID];
        }
        pageState.countries = countryCode ? countryCode : null;
      }
      
      pageState.groupBy = groupByArg;

      const url =  AppHelper.join_paths( PagesHelper.getBasePath(),  PagesHelper.getPageUrl(PageName.products, pageState) );
      scope.dashboardV2Link = encodeURI(url);

      return params;
    }

    return {
      restrict: 'E',
      transclude: true,
      scope: { campaign: '=', app: '=', clink: '=', title: '@', icon: '=' },
      controller: ['$scope', 'AppHelper', 'ngDialog', function ($scope, AppHelper, ngDialog) {        
        $scope.isAdminUser = window.permissions.indexOf(UserPermissions.appptapDataFullAccess) >= 0;
        $scope.isAllowedCampaigns = window.permissions.indexOf(UserPermissions.apptapDataCampaigns) >= 0;
        $scope.isAllowedRTBData = ( window.permissions.indexOf(UserPermissions.appptapDataFullAccess) >= 0 ) || ( window.permissions.indexOf(UserPermissions.appptapDataRtb) >= 0 );
        $scope.isAllowedGrossRevenueData = ( window.permissions.indexOf(UserPermissions.appptapDataFullAccess) >= 0 ) || ( window.permissions.indexOf(UserPermissions.appptapDataGrossRevenue) >= 0 );

        // pull a list of all potential drop-down entries initially and store it for the life of the popup
        $scope.stats_campaigns  = []
        $scope.stats_clinks     = []
        $scope.stats_publishers = []
        $scope.stats_countries  = []

        // Initialize empty dates array - will be populated when dialog opens
        $scope.all_dates = []

        $scope.dataRowsCount = function(rows) {
            return _.filter(rows, function(r) { return true !== r.key.total; }).length;
        }

        // Get current date range description for the dropdown
        $scope.getCurrentDateRangeDescription = function() {
          // Use the all_dates array length if available
          if ($scope.all_dates && $scope.all_dates.length > 0) {
            const actualDays = $scope.all_dates.length;
            return `last ${actualDays} day${actualDays === 1 ? '' : 's'}`;
          }

          // Fallback to data if all_dates not set yet
          if ($scope.data && $scope.data.day && $scope.data.day.length > 0) {
            // Count actual data rows (exclude totals)
            const actualDays = _.filter($scope.data.day, function(r) { return true !== r.key.total; }).length;
            if (actualDays > 0) {
              return `last ${actualDays} day${actualDays === 1 ? '' : 's'}`;
            }
          }

          // Final fallback
          return 'last 7 days';
        };

        $scope.refresh = function() {
          const groupBy = $scope.dashboardLinkGroupby ? $scope.dashboardLinkGroupby : ColumnIds.date;
          const params = setDashboardV2LinkAndGetParams(groupBy,$scope);

          // current Jupiter front doesn't handle an empty data parameter properly,
          // so only add the parameter if there's a value to pass
          // TODO: fix the Jupiter front handling
          if ( $scope.options.selected_date ) {
            params['date'] = $scope.options.selected_date;
          }

          // match the selected publisher to the selected cLink since that's a 1:1 mapping
          // but the other way isn't achievable
          selectCLinkPublisher($scope)

          // load the updated reporting data
          $scope.loading = true;
          AppHelper.getSummarizedStats(
            params,
            function (data) {
              $scope.data = data;
              $scope.loading = false;

              // Update dates based on the actual data if this is the first load
              // Only update if we haven't set a specific date yet (initial load)
              if (!$scope.options.selected_date && data && data.day && data.day.length > 0) {
                // Count actual days excluding the total row
                const dataRows = _.filter(data.day, function(r) { return true !== r.key.total; });
                const dayCount = dataRows.length;

                // Regenerate the all_dates array based on the actual number of days in the data
                $scope.all_dates = [];
                var d = new Date();
                for (var i = 0; i < dayCount; i++) {
                  $scope.all_dates.push(d.toJSON().substr(0,10));
                  d.setDate(d.getDate()-1);
                }

                // Ensure selected_date remains null after all_dates is populated
                // This prevents AngularJS from auto-selecting the first option
                $scope.options.selected_date = null;
              }

              refresh_options($scope);

              // Regenerate the dashboard link now that we have the actual date data
              const groupBy = $scope.dashboardLinkGroupby ? $scope.dashboardLinkGroupby : ColumnIds.date;
              setDashboardV2LinkAndGetParams(groupBy, $scope);

              $scope.$apply();
            }
          );
        }
      
        $scope.open = function() {
          if ($scope.app) {
            $scope.app_name = $scope.app.title
            $scope.app_id = $scope.app.appID
          } else if ($scope.clink) {
            $scope.app_name = $scope.clink.app_name
            $scope.app_id = $scope.clink.app_id
          }

          $scope.campaigns = null;
          if ( $scope.app && $scope.app.campaigns ) {
            $scope.campaigns = $scope.app.campaigns;
          } else if ( $scope.clink && $scope.clink.campaigns ) {
            $scope.campaigns = $scope.clink.campaigns;
          }

          // Generate dates BEFORE opening the dialog
          $scope.all_dates = []
          const currentPageState = StateHelper.getPageState();

          if (currentPageState.dateStart && currentPageState.dateEnd) {
            // Use actual date range from page state
            const startDate = dayjs(currentPageState.dateStart);
            const endDate = dayjs(currentPageState.dateEnd);
            const daysDiff = endDate.diff(startDate, 'days') + 1; // +1 because both start and end are inclusive

            // Generate dates backwards from end date
            for (let i = 0; i < daysDiff && i < 30; i++) { // Limit to 30 days to avoid too many options
              const date = endDate.subtract(i, 'day');
              $scope.all_dates.push(date.format('YYYY-MM-DD'));
            }
          } else {
            // Fallback to 7 days if no date range is set
            var d = new Date()
            for ( var i = 0; i < 7; i++ ) {
              $scope.all_dates.push( d.toJSON().substr(0,10) )
              d.setDate(d.getDate()-1)
            }
          }

          $scope.dialog = ngDialog.open({
            template: 'static/dialogs/summarizedStats.html',
            scope: $scope,
            className: 'ngdialog-theme-default counters-dialog ngdialog-full-screen'
          });

          refresh_options($scope)

          $scope.options = {
            'selected_clink': $scope.clink ? map_clink_for_options($scope.clink) : $scope.options_clinks[0],
            'selected_campaign': $scope.campaign ? map_campaign_data_for_options($scope.campaign) : $scope.options_campaigns[0],
            'selected_date': null,
            'selected_country': $scope.options_countries[0],
            'selected_publisher': $scope.options_publishers[0],
          }
          selectCLinkPublisher($scope);
          
          AppHelper.getSummarizedStats(
            {
              'appID': $scope.app == null ? $scope.clink.app_id : $scope.app.appID,
              'keysonly': true,
              'aggregator': ['clink', 'country', 'campaign', 'publisher']
            },
            function (data) {
              if ( $scope.isAllowedCampaigns ) {
                if ( 'campaign' in data ) {
                  $scope.stats_campaigns = _.map( 
                    _.filter( Object.values(data['campaign']), function(d) { return d['key']['campaignID'] !== '*APP' } ),
                    function(d) { return map_campaign_data_for_options( d['key'] ) }
                  )
                }
              }

              if ( 'clink' in data ) {
                $scope.stats_clinks = _.map(Object.values(data['clink']), function(k) { return k['key'] })
              }

              if ( 'country' in data ) {
                $scope.stats_countries = _.map(Object.values(data['country']), function(k) { return k['key'] })
              }

              if ( 'publisher' in data ) {
                $scope.stats_publishers = _.map(Object.values(data['publisher']), function(k) { return k['key'] })
              }

              refresh_options($scope)
            }
          )

          $scope.refresh();
        };

        $scope.update = function () {
          $scope.dialog.close();
          $scope.date = this.selectedDate;
          $scope.open();
        };

        $scope.setDropdownValue = function () {
          return $scope.date || ($scope.campaignData ? $scope.campaignData.availableDates[0] : undefined);
        };

        $scope.onTabSelect=function(tabName){
          let groupbyArg = "";

          switch( tabName ){
            case "dates":
            case "hours":
            case "day_hour":
              groupbyArg = ColumnIds.date;
              break;
            case "publishers":
              groupbyArg = ColumnIds.apptapPublisherID + "," + ColumnIds.apptapSiteID;
              break;
            case "countries":
              groupbyArg = ColumnIds.country;
              break;
            case "clinks":
              groupbyArg = ColumnIds.apptapPublisherID + "," + ColumnIds.apptapSiteID + "," + ColumnIds.cLinkId + "," + ColumnIds.cLinkOwner;
              break;
            case "campaigns":
              groupbyArg = ColumnIds.campaignSource + "," + ColumnIds.campaignID;
              break;
            default:
              groupbyArg = ColumnIds.date;
          }

          $scope.dashboardLinkGroupby = groupbyArg;
          
          setDashboardV2LinkAndGetParams(groupbyArg,$scope);
        }

      }],
      templateUrl: 'static/templates/summarizedStatsButton.html',
      replace: true
    };
  })

.directive('clinkstable', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: { apps: '=?', clinks: '=?', tab: '=', currentSearch: '=', fetchAppData: '&' },
    controller: ['AppHelper', '$scope', '$attrs', '$q', '$rootScope', '$filter', function( AppHelper, $scope, $attrs, $q, $rootScope, $filter ) {
      $scope.isAdminUser = $scope.$parent.isAdminUser
      $scope.isAllowedCampaigns = $scope.$parent.isAllowedCampaigns;
      $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData
      $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
      $scope.canEditCLink = $scope.$parent.canEditCLink
      $scope.canEditClinkField = $scope.$parent.canEditClinkField
      $scope.currentUser = $scope.$parent.currentUser
      $scope.bulk_edit_mode = false;
      $scope.bulk_edit_all_selected = false;
      $scope.currentSearch = $rootScope.currentSearch;

      // this can take either an "apps" or "clinks" array - map whichever is provided
      // into a list of clinks - if apps, then this "flattens" the apps' clinks into
      // a single list - this will auto-update if $scope.clinks or $scope.apps change
      $scope.data = function() {
        var ret  = []

        if ( $scope.clinks ) {
          ret = $scope.clinks;
        } 
        else if ( $scope.apps ) {
          _.each($scope.apps, function(app) {
            _.each(app.clinks, function(clink) {
              ret.push(clink);
            })
          });
        } 

        return ret;
      };

      $scope.$watch( 
        function( scope ) { 
          return $scope.apps 
        }, 
        function() {
            $scope.bulk_edit_mode = false;
        } 
      );
    
      $scope.edit = function( clink_id ) {
        $scope.parent.openClinkToEdit()
  			// conflict with react router
        // window.location = window.location.pathname.replace("campaign_links", "campaign_lookup") + "#modify/" + clink_id;
      };      

      $scope.showMoreApps = function( ) {
        $scope.tab.maxApps += 50;
      };

      $scope.buildConfiguredPayoutTooltip = function ( clink, isAdminUser ) {
        if (clink.configs[0].user_rev_share_p2p) {
          let message = 
            isAdminUser ? "Expected payout to publisher after rev-share. Payout will be a percentage of the credited payout to Kepler, and will vary depending on a number of factors. This will pay the publisher at (" + (clink.publisher_rev_share ? $filter('percentage')((clink.publisher_rev_share)) : "unknown") + ") of actual revenue credited to Kepler for a conversion. "
                        : "Payout is based on a rev-share of what Kepler is credited per conversion, and will vary depending on a number of factors."

          if (clink.stats && (clink.stats.todayInstalls || clink.stats.weekInstalls)) {
            message += 
              isAdminUser ? "Average recent payout to publisher per conversion after rev-share: " +  $filter('currency')((clink.stats.todayClicksCost+clink.stats.todayPublisherPayout)/clink.stats.todayInstalls) + " 1d, " +  $filter('currency')((clink.stats.weekClicksCost+clink.stats.weekPublisherPayout)/clink.stats.weekInstalls) + " 7d"
              : " Average recent payout: " + $filter('currency')((clink.stats.todayClicksCost+clink.stats.todayPublisherPayout)/clink.stats.todayInstalls) + " 1d, " +  $filter('currency')((clink.stats.weekClicksCost+clink.stats.weekPublisherPayout)/clink.stats.weekInstalls) + " 7d";
          } else {
            message += isAdminUser ?
              "No recent conversions for this cLink. Actual payout to publisher is unknown."
              : "No recent conversions for this cLink. Actual payout unknown until conversions credit.";
          }
          return message;
        } else {
          if (clink.configs[0].p2p) {
            return "cLink is configured to credit the publisher a fixed payout of (" + $filter('currency')(clink.configs[0].p2p) + ") per credited conversion.";
          } else {
            return "cLink is configured to not credit any revenue to the publisher. This is typically used for platforms where we buy traffic, rather than paying a partner per conversion or credited event.";
          }
        }
      };

      $scope.expandClink = function( clink, $event ) {
        // Now associated campaigns are coming along with the original clink call, however we may need to fetch in the future for optimization.
        // // For requested clinks in admin mode, if there are no campaigns, then show the "matching campaigns" based on the criteria of the clink.
        // if ( $scope.isAdminUser() && clink.status == "REQUESTED" && !clink.campaignsFetched ) {
        //    // First time expansion for this clink, fetch the matching campaigns.
        //	$scope.fetchMatchingCampaignsForRequestedClink( clink );
        // }

        if ( clink.expanded ) {
          clink.expanded = false;
          clink.bulk_edit_mode = false;
          return;
        }

        if ( !clink.campaigns ) {
          if ($scope.fetchAppData) {
            $scope.fetchAppData()( clink ).then( function() {
              clink.expanded = true;
            });
          }
        } else {
          clink.expanded = true;
        }
      };

      $scope.isBrandProduct = function( productID ) {
        return productID.startsWith( "tile." );
      }

      $scope.sortClinksBy = function( column ) {
        var startReversed = false;
        
        if ( !$scope.clink_sort ) {
          $scope.clink_sort = {}
        }

        switch( column ) {
          case 'Product': 
            $scope.clink_sort.comparison = 'app_name'
            break;
          case 'Health':
            $scope.clink_sort.comparison = 'health';
            break;
          case 'Publisher':
            $scope.clink_sort.comparison = 'pub_id';
            break;
          case 'Sources':
            $scope.clink_sort.comparison = 'configs[0].campaigns[0].source';
            break;
          case 'Updated':
            $scope.clink_sort.comparison = 'last_update';
            break;
          case 'cLinkID':
            $scope.clink_sort.comparison = 'clink_id';
            break;
          case 'Platform':
            $scope.clink_sort.comparison = 'configs[0].platforms';
            break;
          case 'Countries':
            $scope.clink_sort.comparison = 'configs[0].countries';
            break;
          case 'Payout':
            $scope.clink_sort.comparison = function( row ) { 
              if ( row.configs[0].p2p > 0 ) return row.configs[0].p2p;
              return 0;
            };
            startReversed = true;
            break;
          case 'DailyCap':
            $scope.clink_sort.comparison = 'configs[0].daily_cap_sort';
            startReversed = true;
            break;
          case 'MinOS':
            $scope.clink_sort.comparison = 'os_version';
            break;
          case 'EndDate':
            $scope.clink_sort.comparison = 'end_date';
            break;
          case 'Incent':
            $scope.clink_sort.comparison = 'incent';
            break;
          case 'DeviceIDReq':
            $scope.clink_sort.comparison = 'device_id_req';
            break;
          case 'SourceAppIDReq':
            $scope.clink_sort.comparison = 'source_app_id_req';
            break;
          case 'SourceAppNameReq':
            $scope.clink_sort.comparison = 'source_app_name_req';
            break;
          case 'WeekClicks':
            $scope.clink_sort.comparison = 'stats.weekBuys';
            startReversed = true;
            break;
          case 'TodayClicks':
            $scope.clink_sort.comparison = 'stats.todayBuys';
            startReversed = true;
            break;
          case 'TodayInstalls':
            $scope.clink_sort.comparison = 'stats.todayInstalls';
            startReversed = true;
            break;
          case 'WeekInstalls':
            $scope.clink_sort.comparison = 'stats.weekInstalls';
            startReversed = true;
            break;
          case 'TodayFillRate':
            $scope.clink_sort.comparison = 'stats.todayRTBFillRate';
            startReversed = true;
            break;
          case 'WeekFillRate':
            $scope.clink_sort.comparison = 'stats.weekRTBFillRate';
            startReversed = true;
            break;
          case 'TodayUntracked':
            // it's important to not have a division by 0, or that breaks the sort and the data is displayed in random order
            $scope.clink_sort.comparison = function(row){ return row.stats.todayBuys === 0 ? 0 : (row.stats.todayUntracked/row.stats.todayBuys); };
            startReversed = true;
            break;
          case 'WeekUntracked':
            $scope.clink_sort.comparison = function(row){ return row.stats.weekBuys === 0 ? 0 : (row.stats.weekUntracked/row.stats.weekBuys); };
            startReversed = true;
            break;
          case 'TodayCR':
            $scope.clink_sort.comparison = function(row){ return row.stats.todayBuys === 0 ? 0 : (row.stats.todayInstalls/row.stats.todayBuys); }
            startReversed = true;
            break;
          case 'WeekCR':
            $scope.clink_sort.comparison = function(row){ return row.stats.weekBuys === 0 ? 0 : (row.stats.weekInstalls/row.stats.weekBuys); }
            startReversed = true;
            break;
          case 'TodayECPC':
            $scope.clink_sort.comparison = function(row){ return row.stats.todayBuys === 0 ? 0 : (row.stats.todayRevenue/row.stats.todayBuys); };
            startReversed = true;
            break;
          case 'WeekECPC':
            $scope.clink_sort.comparison = function(row){ return row.stats.weekBuys === 0 ? 0 : (row.stats.weekRevenue/row.stats.weekBuys); };
            startReversed = true;
            break;
          case 'TodayAvgCostPerClick':
            $scope.clink_sort.comparison = function(row){ return row.stats.todayBuys === 0 ? 0 : ((row.stats.todayClicksCost+row.stats.todayPublisherPayout)/row.stats.todayBuys); };
            startReversed = true;
            break;
          case 'WeekAvgCostPerClick':
            $scope.clink_sort.comparison = function(row){  return row.stats.weekBuys === 0 ? 0 : ((row.stats.weekClicksCost+row.stats.weekPublisherPayout)/row.stats.weekBuys); };
            startReversed = true;
            break;
          case 'Fulfilled':
            $scope.clink_sort.comparison = 'daily_cap_fulfillment';
            startReversed = true;
            break;
          default: break;
        }
    
        if ( $scope.clink_sort.column === column  ) {
          $scope.clink_sort.reverse = !$scope.clink_sort.reverse;
        }
        else {
          $scope.clink_sort.reverse = startReversed;
        }
        $scope.clink_sort.week = column.includes('Week')
        $scope.clink_sort.base_column = column.replace("Week", "").replace("Today", "").toLowerCase()
        $scope.clink_sort.column = column
      };

      $scope.invokeBulkEditCLinks = function() {
          // Ensure any expanded clinks are collapsed.
          $scope.apps.forEach( ( app ) => app.clinks.forEach( ( clink ) => clink.expanded = false ) );

          // Set the initial state for the bulk edit feature
          $scope.apps.forEach( ( app ) => app.clinks.forEach( ( clink ) => clink.bulk_edit = false ) );
          $scope.bulk_edit_all_selected = false;

          $scope.bulk_edit_mode = true;
      };

      $scope.cancelBulkEditCLinks = function() {
          $scope.bulk_edit_mode = false;
          $scope.apps.forEach( ( app ) => app.clinks.forEach( ( clink ) => clink.bulk_edit = false ) );
      };
      $scope.imgOnError = function(event, clink) {
        clink.app_icon = null;
        event.target.parentElement.display = "none";
      };

      $scope.selectAllForBulkEdit = function() {
        $scope.bulk_edit_all_selected = !$scope.bulk_edit_all_selected

        var c = $scope.data();

        // NOTE: We need the clinks to be ordered in the same way as they are sorted and displayed in the clinks table.
        //       This orderBy filter matches the sorting in clinks_table.html
        //       clink in data() | orderBy : clink_sort.comparison : clink_sort.reverse | limitTo: tab.maxApps
        c = $filter( 'orderBy' )( c, $scope.clink_sort.comparison, $scope.clink_sort.reverse );

        // For selecting, only select up to the current displayed number of clinks (tab.maxApps).  For deselting, deselecting them all.
        for ( var i = 0; i < c.length; i++ ) {
           if ( $scope.bulk_edit_all_selected ) {
             if ( i < $scope.tab.maxApps ) {
                  c[i].bulk_edit = $scope.bulk_edit_all_selected;
             }
           }
           else {
              c[i].bulk_edit = $scope.bulk_edit_all_selected;
           }
        };
      };

      $scope.getCounterBidStatus = function( clink ) {
        var status = "default"

        if ( clink.configs[0].allow_counter_bid_override != null ) {
          status = clink.configs[0].allow_counter_bid_override === true ? "allow" : "disable";
        }
        else if ( clink.configs[0].allow_counter_bid != null ) {
          status = clink.configs[0].allow_counter_bid === true ? "allow" : "disable";
        }
        // else ... neither counter bid setting is set, so the setting is "default".

        return status;
      };

      $scope.closeEditClink = function() {
        $scope.showEditClinkFromAngular = false;
        $scope.$apply();
      }
      $scope.editClink = function(clink) {
        $scope.clink_id = clink.clink_id;
        $scope.showEditClinkFromAngular = true;
      }

      $scope.setShowTrackingLinks = function() {
        $scope.clinkIdToShowTrackingLinks = null;
        $scope.$apply();
      }
      $scope.showTrackingLinks = function(clink) {
        $scope.clinkIdToShowTrackingLinks = clink.clink_id;
      }
      $scope.getDemandSourceLabel = function(demandSourceId) {
        return PagesHelper.getDemandSourceLabel(demandSourceId, false);
      }
      $scope.getTrafficSourceLabel = function(publisherId, siteId) {
        const trafficSources = StateHelper.getTrafficSourcesArray();
        return PagesHelper.getTrafficSourceLabel(publisherId, siteId, trafficSources);
      }
      $scope.reloadClink = function (clinkId, apply) {
        AppHelper.getClink( { 'clinkid': clinkId },
        function(updatedClink) {
          if ( $scope.clinks ) {
            $scope.clinks = $scope.clinks.map((clink) => clink.clink_id === clinkId ? updatedClink : clink);
          } else if ( $scope.apps ) {
            _.each($scope.apps, function(app) {
              app.clinks = app.clinks.map((clink) => clink.clink_id === clinkId ? { ...clink, ...updatedClink } : clink);
            });
          }

          if (apply) $scope.$apply();
        })
      }
      $scope.sortClinksBy('TodayClicks');
    }],
    templateUrl: 'static/templates/clinks_table.html',
  }
})

.directive('productstable', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: { apps: '=', currentSearch: '=', fetchAppData: '&', showOverallMatchedToggle: '@', showCampaigns: '=?', showClinks: '=?', showMatching: '=?', pageType: '@' },
    controller: ['AppHelper', '$scope', '$attrs', '$q', '$rootScope', function( AppHelper, $scope, $attrs, $q, $rootScope ) {
      $scope.showStats = 'overall';
      $scope.maxApps = 50;
      $scope.currentSearch = $rootScope.currentSearch;
      $scope.createClink = $rootScope.createClink;
      $scope.isAdminUser = $scope.$parent.isAdminUser;
      $scope.isAllowedCampaigns = $scope.$parent.isAllowedCampaigns;
      $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData;
      $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
      $scope.canEditCLink = $scope.$parent.canEditCLink
      $scope.canEditClinkField = $scope.$parent.canEditClinkField
      $scope.currentPageType = $scope.pageType
      $scope.currentUser = $scope.$parent.currentUser;

      var tabs = [];
      if ( $scope.showCampaigns && $scope.showMatching ) tabs.push("matchingCampaigns");
      if ( $scope.showCampaigns ) tabs.push("allCampaigns");
      if ( $scope.showClinks && $scope.showMatching ) tabs.push("matchingClinks");
      if ( $scope.showClinks ) tabs.push("allClinks");

      $scope.showSubTabs = tabs.length > 1;
      if ( tabs.length > 0 ) {
        $scope.defaultSubTab = tabs[0];
      }

      if ( $scope.showOverallMatchedToggle ) {
        $scope.$storage = $scope.$parent.$storage;
        if (typeof $scope.$storage.showStats === 'undefined') {
          $scope.$storage.showStats = 'overall';
        }
        $scope.showStats = $scope.$storage.showStats;
      } else {
        $scope.showStats = "";
      }

      $scope.isBrandProduct = function( productID ) {
        return productID.startsWith( "tile." );
      }
      
      $scope.selectTab = function( app, name ) {
        app.selectedTab = name;	
      };    
      
			$scope.setShowStats = function (mode) {
				$scope.showStats = mode;
				$scope.$storage.showStats = mode;
        $scope.$apply();
			}

      $scope.getStats = function(row, subset, period, field) {
        var stats = row.stats;
        if ( subset ) {
          if ( subset[0] === '.' ) {
            stats = stats[subset.substr(1)]
          } else {
            stats = stats[subset]
          }
        }
        return stats[period + field]
      }

      $scope.imgOnError = function(event, app) {
        app.icon = null;
        event.target.parentElement.display = "none";
      };

      $scope.sortAppsBy = function( column ) {
        var startReversed = false;
        
        if ( !$scope.app_sort ) {
          $scope.app_sort = {}
        }

        var period = ""; 
        if ( column.indexOf("Today") === 0 )  {
          period = "today";
        } else if ( column.indexOf("Week") === 0 ) {
          period = "week"
        }

        var subset = "";
        if ( $scope.showStats === 'overall' ) {
          subset = ".overall";
        } else if ( $scope.showStats === 'matched' ) {
          subset = ".matched";
        }

        switch( column ) {
          case 'Issues':
            $scope.app_sort.comparison = 'has_issues';
            break;
          case 'Title':
            $scope.app_sort.comparison = 'title';
            break;
          case 'AppID':
            $scope.app_sort.comparison = 'appID';
            break;
          case 'Platform':
            $scope.app_sort.comparison = 'platforms';
            break;
          case 'Category':
            $scope.app_sort.comparison = 'category';
            break;
          case 'Countries':
            $scope.app_sort.comparison = 'countries';
            break;
          case 'PayoutRange':
            $scope.app_sort.comparison = 'payout_max';
            startReversed = true;
            break;

          case 'TodayClicks':
          case 'WeekClicks':
            $scope.app_sort.comparison = 'stats' + subset + '.' + period + 'Buys';
            startReversed = true;
            break;
          case 'TodayInstalls':
          case 'WeekInstalls':
            $scope.app_sort.comparison = 'stats' + subset + '.' + period + 'Installs';
            startReversed = true;
            break;
          case 'TodayRevenue':
          case 'WeekRevenue':
            $scope.app_sort.comparison = 'stats' + subset + '.' + period + 'Revenue';
            startReversed = true;
            break;	

          case 'TodayUntracked':
          case 'WeekUntracked':          
            $scope.app_sort.comparison = function(row){ 
              return $scope.getStats(row, subset, period, 'Untracked') / 
                     $scope.getStats(row, subset, period, 'Buys')
            };
            startReversed = true;
            break;
          case 'TodayCR':
          case 'WeekCR':
            $scope.app_sort.comparison = function(row){ 
              return $scope.getStats(row, subset, period, 'Installs') / 
                     $scope.getStats(row, subset, period, 'Buys')
            };
            startReversed = true;
            break;

          case 'ToayECPC':
          case 'WeekECPC':
            $scope.app_sort.comparison = function(row){ return row.stats.weekRevenue/row.stats.weekBuys; };
            startReversed = true;
            break;      

          case 'Updated':
            $scope.app_sort.comparison = 'last_update';
            break;
          case 'LastClick':
            $scope.app_sort.comparison = 'last_click';
            break;
          case 'LastInstall':
            $scope.app_sort.comparison = 'last_install';
            break;
          case 'Offers':
            $scope.app_sort.comparison = 'clinks.length';
            startReversed = true;
            break;
          case 'CampaignsMatched':
            $scope.app_sort.comparison = ['counts.appMatchedCampaigns','campaigns.length'];
            startReversed = true;
            break;
          case 'CampaignsTotal':
            $scope.app_sort.comparison = ['counts.appCampaigns','campaigns.length'];
            startReversed = true;
            break;  
            case 'cLinksMatched':
            $scope.app_sort.comparison = ['counts.appMatchedClinks','clinks.length'];
            startReversed = true;
            break;
          case 'cLinksTotal':
            $scope.app_sort.comparison = ['counts.appClinks','clinks.length'];
            startReversed = true;
            break;

          default: break;
        }	
    
        if ( $scope.app_sort.column === column  ) {
          $scope.app_sort.reverse = !$scope.app_sort.reverse;
        }
        else {
          $scope.app_sort.reverse = startReversed;
        }
        $scope.app_sort.week = column.includes('Week')
        $scope.app_sort.base_column = column.replace("Week", "").replace("Today", "").toLowerCase()
        $scope.app_sort.column = column		
      }

      $scope.expandApp = function( app ) {
        if ( app.expanded ) {
          app.expanded = false;
          app.bulk_edit_mode = false;
          return;
        }

        // if a specific tab isn't being shown, then use either the defaultSubTab passed in, or matchingCampaigns if not
        if ( !app.selectedTab ) {
          $scope.selectTab(app, $scope.defaultSubTab);		
        }
        
        // if the data is sparse (no campaign or clinks data) and there's
        // a method to enhance the data, then call that
        if ( !app.clinks && !app.campaigns ) {
          if ( $scope.fetchAppData ) {
            $scope.fetchAppData()( app ).then( function() {
              app.expanded = true;
            });
          } else {
            // TODO: how do we really want to handle this
            alert("Unable to expand - no further data available.");
          }
        } else {
          app.expanded = true;
        }
      };

      $scope.expandDetailsShortcut = function( app, name ) {
        if ( app.expanded ) {
          $scope.selectTab( app, name );
        } else {
          $scope.selectTab( app, name );
          $scope.expandApp( app  );
        }
      };

      $scope.showMoreApps = function( ) {
        $scope.maxApps += 50;
      };      

      // when a single app is returned, expand it by default
      if ( $scope.apps && $scope.apps.length === 1 ) {
				$scope.expandApp($scope.apps[0])
			}

      $scope.closeCreateClink = function() {
        $scope.showCreateClinkFromAngular = false;
        $scope.$apply();
      }
      $scope.createClink = function (app, campaign) {
				$scope.app = app;
        $scope.showCreateClinkFromAngular = true;
			};
      $scope.sortAppsBy('TodayClicks');
    }],
    templateUrl: 'static/templates/products_table.html',
  }
})

.directive('campaigndatepicker', function() {
    return {
        restrict: 'E',
        transclude: true,
        scope: false,
        controller: ['$scope', function( $scope ) {
            $scope.campaignDatePicker = {
                open: function( $event ) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.campaignDatePicker.opened = true;
                },

                today: function() {
                    $scope.$storage.newSinceDate = new Date();
                },

                clear: function() {
                    $scope.$storage.newSinceDate = null;
                },

                dateOptions: {
                    formatYear: 'yy',
                    startingDay: 1
                }
            };
        }],
        templateUrl: 'static/templates/datePicker.html',
        replace: false
    };
})

.directive('payoutrangechart', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { range: '=', xmin: '@', xmax: '@' },
    controller: ['$scope', function( $scope ) {
        if ( $scope.range != null ) {
            $scope.rangecount = $scope.range.countNonNull;
            $scope.rangemin   = $scope.range.min;
            $scope.rangemax   = $scope.range.max;
            $scope.rangeavg   = $scope.range.mean;
        } else {
            $scope.rangecount = 0;
            $scope.rangemin   = 0;
            $scope.rangemax   = 0;
            $scope.rangeavg   = 0;
        }        
        $scope.scaledavg = 10 + 100.0 * ( $scope.rangeavg - $scope.xmin ) / ($scope.xmax - $scope.xmin)
        $scope.scaledmin = 10 + 100.0 * ( $scope.rangemin - $scope.xmin ) / ($scope.xmax - $scope.xmin)
        $scope.scaledmax = 10 + 100.0 * ( $scope.rangemax - $scope.xmin ) / ($scope.xmax - $scope.xmin)
    }],
    templateUrl: 'static/templates/payoutRangeChart.html',
    replace: true
  };
})

.directive('percentbarchart', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { successes: '=', attempts: '=', successcolor: '@', failcolor: '@' },
    controller: ['$scope', function( $scope ) {
        $scope.scaledSuccesses = ((                  $scope.successes) / $scope.attempts) * 100; 
        $scope.scaledFails     = (($scope.attempts - $scope.successes) / $scope.attempts) * 100; 
    }],
    templateUrl: 'static/templates/percentBarChart.html',
    replace: true
  };
})

.directive('summarizedstatstable', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: { rows: '=', keycol:'@', keycolname: '@', keycolparam: '@', orderby: '@'  },
    controller: ['$scope', function( $scope ) {
        $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData;
        $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
        $scope.isAllowedCampaigns = $scope.$parent.isAllowedCampaigns;

        $scope.filteredRows = function( rows ) {
            if ( !rows ) return [];
            return rows.filter( (r) => r['key']['total'] !== true );
        }
        $scope.totalRow    = function( rows ) {
            if ( !rows ) return [];
            return rows.filter( (r) => r['key']['total'] === true );
        }
    }],
    templateUrl: 'static/templates/summarizedStatsTable.html',
    replace: true
  };
})


.directive('summarizedstatsrow', function() {
  return {
    restrict: 'A',
    transclude: true,
    scope: { data: '=', keycol:'@', keycolname: '@', keycolparam: '@'  },
    controller: ['$scope', '$filter', function( $scope, $filter ) {
        $scope.isAllowedRTBData = $scope.$parent.isAllowedRTBData;
        $scope.isAllowedGrossRevenueData = $scope.$parent.isAllowedGrossRevenueData;
        $scope.isAllowedCampaigns = window.permissions.indexOf(UserPermissions.apptapDataCampaigns) >= 0;

        if ( $scope.data.key.total === true ) {
            $scope.keyColValue = "Total";
            $scope.footer = true;
        } else {
            $scope.keyColValue = $scope.$eval('data.' + $scope.keycol);
            $scope.footer = false;
        }  

        $scope.getPayoutChartTooltipText = function( label, dataRange ) {
            if ( dataRange == null || dataRange.mean == null ) {
              return null;
            }

            var decimals = ( ( dataRange.min > 0.0 && dataRange.min < 0.01 ) || ( dataRange.max > 0.0 && dataRange.max < 0.01 ) || ( dataRange.mean  > 0.0 && dataRange.mean < 0.01 ) ) ? 4 : 2;
            var text = label + "<br>Avg: " + $filter( 'currency' )( dataRange.mean, '$', decimals ) + "<br>Min: " + $filter( 'currency' )( dataRange.min, '$', decimals ) + "<br>Max: " + $filter( 'currency' )( dataRange.max, '$', decimals );
            return text;
        };
    }],
    templateUrl: 'static/templates/summarizedStatsRow.html',
    replace: true
  };
})


.filter("padDigits", function() {
	return function(number, width) {
		return (Array(width).join("0")+number).slice(-width);
	};
})

.filter("roundPercentage", function() {
	return function foo(number, decimalPlaces) {
		if ( !isFinite(number) ) return '';
		return (100*number).toFixed( decimalPlaces||0 ) +'%';
	};
})

// Used in conjunction with the "negativeNumber" class.
.filter( "currency_negative", function() {
  return function( number ) {
    if ( number < 0.0 ) number *= -1;
    return "$" + number.toLocaleString( "en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }  );
  }
})

.filter( "currency_cents", function() {
  return function( number ) {
    return ( number * 100.0 ).toLocaleString( "en", { minimumFractionDigits: 1, maximumFractionDigits: 1 }  ) + "¢";
  }
})

.filter("thresholdClass", function() {
	return function(number) {
		number *= 100;
		return !isFinite(number) ? '' : number > 105 ? 'capExceeded' : number > 95 ? 'capped' : number > 85 ? 'nearCap' : '';
	};
})

.constant( '_', window._ )

.factory('AppHelper', function() {
	return new AppHelper();
})

.filter('reverse', function() {
  return function(items) {
    return items.slice().reverse();
  };
})

.filter('parse_iso_date', function() {
  return function(s) {
    if ( s == null ) return null;
    if ( s.length === 10 ) {
      return new Date(s.substr(0,4), s.substr(5,2)-1, s.substr(8,2));
    } else if ( s.length === 8 ) {
      return new Date(s.substr(0,4), s.substr(4,2)-1, s.substr(6,2));
    }
  }
})

.filter('timeago', function() {
    return function(input, p_no_value_string, p_suffix, p_cutoff_secs, p_cutoff_str) {
    	if ( !input ) return p_no_value_string;
    	if ( !p_suffix          ) p_suffix = "";
    	if ( !p_no_value_string ) p_no_value_string = "";
    	if ( !p_cutoff_secs     ) p_cutoff_secs = -1;
    	if ( !p_cutoff_str      ) p_cutoff_str = "";
    	
        var now  = (new Date()).getTime();
        var date = (new Date(input)).getTime();
        var diff = now - date;

        if ( p_cutoff_secs && diff/1000 < p_cutoff_secs ) {
        	return p_cutoff_str + p_suffix;
        }
        
        var seconds = Math.abs(diff) / 1000;        
        var minutes = ( seconds / 60 ) | 0;
        var hours = ( minutes / 60 ) | 0;
        var days = ( hours / 24 ) | 0;
        var years = ( days / 365 ) | 0;

        if ( years >= 1 ) {
            return years + "y " + (days - (365*years)) + "d" + p_suffix;
        }
        if ( hours >= 48 ) {
            return days + "d" + p_suffix;
        }
        if ( hours >= 1 ) {
            return hours + "h" + p_suffix;
        }
        return minutes + "m" + p_suffix;
    };
})

.filter('friendlyStatus', function() {
  return function( status ) {
    if ( !status ) {
      return "???";
    }

    var ret = status.split( '_' );
    for ( var i = 0; i < ret.length; i++ ) {
      ret[i] = ret[i].toLowerCase();
      ret[i] = ret[i].charAt( 0 ).toUpperCase() + ret[i].slice(1);
    }

    return ret.join( " " );
  }
})

// takes a comma separated list of countries and:
// splits into an array
// limits to the max number specified
// finds the key countries of interest (US, MX) and puts them first
// adds a "+numremaining" at the end
// returns html of countrie, some in spans with the class "countryImportant" (countries like US,MX,etc,
// which matter most to our business), with potentially another "countryOverflow" span class at the end
// indicating how many countries were dropped
.filter( 'prepareCountriesForDisplay', function() {
	return function( countries, max, useHTML ) {
		// arbitrary list of countries that are most important to us right now in terms of revenue for 2016-11
		// MX is moved to the front due to our direct carrier placements in MX
		var t1 = ["ALL", "US","MX","JP","IN","KR","DE","RU","BR","FR","ID","GB","SA","AU","TW","CA"];

		if ( !countries ) {
      return "???";
		} else {
			countries = countries.split(",");
		}
		
		var ret = [];
		
		// find the "t1" countries first, and move them to the start of the return list 
		for ( var i = 0; i < t1.length; i++ ) {
			var cc = t1[i];
			var idx = countries.indexOf( cc );
			if ( idx >= 0 ) {
				if ( useHTML ) {
					ret.push('<span class="countryImportant">' + cc + '</span>');
				} else {
					ret.push(cc);
				}
				countries[idx] = "";
			}
		}
				
		// add all of the countries not caught by the "t1" list
		countries.sort();
		for ( let i = 0; i < countries.length; i++ ) {
			let cc = countries[i];
			if ( cc.length > 0 ) {
				ret.push( cc );
			}
		}
		
		// apply a bit of slop - it's a big pet peeve of ours to have a result-set say
		// "+1 more" rather than just show the slight overflow, so this won't show the "more"
		// unless there's more than 2 to slop
		if ( max && ret.length > max+2 ) {
			var rem = ret.length-max;
			
			ret = ret.slice( 0, max );
			if ( useHTML ) {
				ret.push('<span class="countryOverflow">+' + rem + '</span>');
			} else {
				ret.push("+" + rem);
			}
		}
		
		return ret.join(" ");
	}
})

.directive('dayweeksort', function() {
	return {
	  restrict: 'E',
	  scope: { columnname: '@', title: '@', currentsort: '=', clickfunction: '=', alttitle: '@' },
	  controller: ['$scope', function($scope) {
      $scope.click = function(col) { $scope.clickfunction(col); }
      $scope.todaycolumn = 'Today' + $scope.columnname;
      $scope.weekcolumn = 'Week' + $scope.columnname;
	  }],
	  template: '<span data-ng-click="click(weekcolumn)">{{alttitle ? alttitle : title}}</span>' + 
              '<br><span class="todayWeekSort">' +
              '<span data-ng-click="click(todaycolumn)" data-ng-class="{sortToday: true, selected: currentsort.column == todaycolumn, ascending: currentsort.column == todaycolumn && !currentsort.reverse}">1d</span>' +
              ' / ' +
              '<span data-ng-click="click(weekcolumn)" data-ng-class="{sortWeek: true, selected: currentsort.column == weekcolumn, ascending: currentsort.column == weekcolumn && !currentsort.reverse}">7d</span>' +
              '</span>'
	};
})

.directive('singlesort', function() {
	return {
	  restrict: 'E',
	  scope: { columnname: '@', title: '@', currentsort: '=', clickfunction: '=', hidearrow: '=', columntitle: '@' },
	  controller: ['$scope', function($scope) {
      $scope.click = function() { $scope.clickfunction($scope.columnname); }
      $scope.displaytitle = $scope.columntitle ? $scope.columntitle : $scope.title;
	  }],
	  template: '<span data-ng-click="click()" data-ng-class="{singleSort: true, selected: !hidearrow && currentsort.column == columnname, ascending: currentsort.column == columnname && !currentsort.reverse}">{{displaytitle}}</span>'
	};
})

;

export default app;